/* eslint-disable no-prototype-builtins */
/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
import { GenericNotificationMessage } from '@/flightpath-components/models/mqttPayload/GenericNotificationMessage';
import { NotificationMessageType } from '@/flightpath-components/models/NotificationMessageType';
import NotificationStore from '@/store/modules/notifications';
import { getModule } from 'vuex-module-decorators';
import { Views } from '@/models/Views';

/**
 * Mixin for enabling Notifications
 */

@Component
export default class NotificationMixIn extends Vue {
  notificationStore = getModule(NotificationStore, this.$store);

  get snackBar(): boolean {
    return this.notificationStore.snackbar;
  }
  set snackBar(state: boolean) {
    this.notificationStore.setSnackbar(state);
  }

  get alertMessage(): string {
    return this.notificationStore.message;
  }

  showNotification(message: string) {
    this.notificationStore.setMessage(message);
  }
  processNotification(message: GenericNotificationMessage) {
    switch (message.Type) {
      case NotificationMessageType.MissionStart:
        this.showNotification(
          `${this.$t('notifications.Mission')} ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.started'
          )}`
        );
        break;
      case NotificationMessageType.MissionPause:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.paused'
          )}`
        );
        break;
      case NotificationMessageType.MissionCompleted:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.completed'
          )}`
        );
        break;
      case NotificationMessageType.MissionCancelled:
        this.showNotification(
          `${this.$t('notifications.Mission')}  ${message.MessageValues[0]} ${this.$t('notifications.for')} ${message.MessageValues[1]} ${this.$t(
            'notifications.cancelled'
          )}`
        );
        break;
      case NotificationMessageType.NewField:
        this.showNotification(`${this.$t('notifications.Field')} ${message.MessageValues[0]} ${this.$t('notifications.created')}`);
        break;
      case NotificationMessageType.NewPath:
        this.showNotification(`${this.$t('notifications.Path')} ${message.MessageValues[0]} ${this.$t('notifications.created')}`);
        break;
      case NotificationMessageType.ModifiedField:
        this.showNotification(`${this.$t('notifications.Field')} ${message.MessageValues[0]} ${this.$t('notifications.modified')}`);
        break;
      case NotificationMessageType.ModifiedPath:
        this.showNotification(`${this.$t('notifications.Path')} ${message.MessageValues[0]} ${this.$t('notifications.modified')}`);
        break;
      default:
        break;
    }
  }

  UpdateNotifyIndications(fieldDate: Date, pathDate: Date, missionDate: Date) {
    for (const key in Views) {
      const result = this.notificationStore.lastModifiedState;
      const date = !result.hasOwnProperty(key) ? null : new Date(result[key]) ?? null;

      switch (key) {
        case Views.Fields:
          if (date == null || date.getTime() < fieldDate.getTime()) {
            this.notificationStore.updateCounterNotification({ Type: NotificationMessageType.NewField.toString(), Value: true });
          }
          break;

        case Views.Paths:
          if (date == null || date.getTime() < pathDate.getTime()) {
            this.notificationStore.updateCounterNotification({ Type: NotificationMessageType.NewPath.toString(), Value: true });
          }
          break;

        case Views.InProgressMisions:
          if (date == null || date.getTime() < missionDate.getTime()) {
            this.notificationStore.updateCounterNotification({ Type: NotificationMessageType.MissionStart.toString(), Value: true });
          }
          break;

        case Views.CompletedMissions:
          if (date == null || date.getTime() < missionDate.getTime()) {
            this.notificationStore.updateCounterNotification({ Type: NotificationMessageType.MissionCompleted.toString(), Value: true });
          }
          break;

        default:
          break;
      }
    }
  }
}
